<div>
    <app-layer-group-title
        [groupInfo]="groupInfo"
        [showShowAllButton]="
            !!(searchKeyExists$ | async) && numOfVisibleLayers !== (layers$ | async)!.length
        "
        [showHideAllButton]="!!numOfVisibleLayers"
        (selectLayerGroup)="layerGroupSelected($event)"
        (showAllLayers)="showAllLayers()"
        (hideAllLayers)="hideAllLayers()"
    ></app-layer-group-title>
    <div>
        <ng-container *ngFor="let layer of layers$ | async">
            <app-layer-group-item
                [layer]="layer"
                (selectLayer)="layerSelected($event)"
            ></app-layer-group-item>
        </ng-container>
    </div>
</div>
